import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/ErrorPage.scss";

export default function ErrorPage() {
  const navigete = useNavigate();
  const handleBack = () => {
    navigete("/device/deviceHome");
  };
  return (
    <>
      <div className="error-wrap">
        <div className="error-main">
          <div className="error-bg"></div>
          <p className="error-text">
            大人您的页面迷失了方向 小的正在努力寻找中......
          </p>
          <span className="error-btn" onClick={handleBack}>
            返回首页
          </span>
        </div>
      </div>
    </>
  );
}
